/* eslint-disable */
import TagManager from "react-gtm-module";
import {MOCK, PUBLIC_ROUTES, REACT_APP_ENV} from "utils/constants";
import jwtDecode from 'jwt-decode';
import moment from "moment/moment";
import { RuntimeEnviroment } from "@company-mrv/mrv-design-system/components";
import { downloadLaudoNew } from "../services/va";
import { downloadDocumentNew } from "../services/ec";
import { saveAs } from 'file-saver';

// eslint-disable-next-line
export const cpfMask = [/\d/,/\d/,/\d/, ".",/\d/,/\d/, /\d/,".",/\d/,/\d/,/\d/,"-",/\d/,/\d/];

// CNPJ alfanumérico: os 12 primeiros caracteres aceitam letras ou dígitos,
// os 2 dígitos verificadores seguem numéricos.
// eslint-disable-next-line
export const cnpjMask = [/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,".",/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,".",/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,"/",/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,/[a-zA-Z0-9]/,"-",/\d/,/\d/];

export const applyCpfCnpjMask = rawValue => {
  const valueWithoutMask = rawValue.replace(/[^a-zA-Z0-9]/g, "");
  if (valueWithoutMask.length > 11 || /[a-zA-Z]/.test(valueWithoutMask))
    return cnpjMask;
  return cpfMask;
};

export const gtmDataLayerPush = (event, dataLayer) => {
  TagManager.dataLayer({
    dataLayer: { event, ...dataLayer }
  });
};

export const capitalize = text => {
  const newText = text.toLowerCase();
  return newText.replace(/(?:^|\s)\S/g, a => {
    return a.toUpperCase();
  });
};

export const resolveName = userObj => {
  const getNickname = () => {
    return userObj && userObj.profile && userObj.profile.nickname
      ? userObj.profile.nickname
      : null;
  };

  const getName = () => {
    if (userObj && userObj.profile && userObj.profile.name) {
      let name = userObj.profile.name.split(" ")[0];
      name =
        name
          .split(" ")[0]
          .charAt(0)
          .toUpperCase() + name.slice(1).toLowerCase();

      return name;
    }
    return "";
  };

  return getNickname() || getName();
};

export const formatData = dataCont => {
  const data = new Date(dataCont);
  const dia = data.getDate().toString();
  const diaF = dia.length === 1 ? `0${dia}` : dia;
  const mes = (data.getMonth() + 1).toString();
  const mesF = mes.length === 1 ? `0${mes}` : mes;
  const anoF = data.getFullYear();
  return `${diaF}/${mesF}/${anoF}`;
};

export const formatCurrency = value => {
  const resolvedValue = value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2
  });
  return `R$ ${resolvedValue}`;
};

export const isRoutePublic = pathname =>
  PUBLIC_ROUTES.some(route => pathname.includes(route));

export class CountTime {
  begin = 0;

  constructor() {
    this.begin = Date.now();
  }

  getTotal = () => {
    const total = Date.now() - this.begin;
    return total / 1000;
  };
}

export const isTodayVA = (date) => {
  return moment(date).isSame(moment(), 'day');
}

const base64ToBlob = (base64, contentType = 'application/pdf') => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

export const doDownload = (dataUrl, filename) => {
  const base64Data = dataUrl.split(',')[1];

  if (!base64Data) {
    console.error('URL de dados inválida.');
    return;
  }
  const blob = base64ToBlob(base64Data, 'application/pdf');
  saveAs(blob, filename);
};

export const getUserIdByAccessToken = token => {
  try {
    const decoded = jwtDecode(token);
    if (decoded.client_id) {
      return decoded.client_id;
    }

    return undefined;
  } catch (e) {
    return undefined;
  }
}

export const getUserIdSubByAccessToken = token => {
  try {
    const decoded = jwtDecode(token);
    if (decoded.sub) {
      return decoded.sub;
    }
  } catch (e) {}
  return undefined;
}

export const getOidcToken = () => {
  try{
    const keys = Object.keys(localStorage);
    for (let i = 0; i < keys.length; i++) {
      if(MOCK) {
        if(keys[i].indexOf('IDSAuthMock') > -1) {
          return JSON.parse(localStorage.getItem(keys[i])).access_token;
        }
      } else {
        if(keys[i].indexOf('oidc.user:') > -1) {
          return JSON.parse(localStorage.getItem(keys[i])).access_token;
        }
      }
    }
  }catch (e) {
    return null;
  }
}

const detectMob = () => {

  if(window.ReactNativeWebView) {
    return true;
  }

  const toMatch = [ /Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

  return toMatch.some((toMatchItem) => {
    return navigator?.userAgent?.match(toMatchItem);
  });
}

export const isMobileOrTablet = () => {
  return (navigator?.userAgentData?.mobile || detectMob());
}

export const formatDateParseZone = (date, format = 'DD/MM/YY') => {
  const dateMoment = moment.parseZone(date);
  return dateMoment.format(format);
}

export const formatDate = (date, format = 'DD/MM/YY') => {
  const dateMoment = moment(date);
  return dateMoment.format(format);
}

export const formatDateUtc = (date, format = 'DD/MM/YY') => {
  const dateMoment = moment.utc(date);
  return dateMoment.format(format);
}

export const getMobileOperatingSystem = () => {

  if(window.ReactNativeWebView) {
    if (window['nativePlatform'] === 'android') {
      return 'Android';
    } else if (window['nativePlatform'] === 'ios') {
      return 'iOS';
    }
  }

  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) ) {
    return 'iOS';
  }
  else if( userAgent.match( /Android/i ) ) {

    return 'Android';
  }
  else {
    return 'unknown';
  }
}

export const checkRuntimeEnviroment = () => {
  switch (REACT_APP_ENV) {
    case "DEV":
      return RuntimeEnviroment.Development;
    case "QAS":
      return RuntimeEnviroment.Qas;
    case "SIM":
        return RuntimeEnviroment.Sim;
    case "PRD":
      return RuntimeEnviroment.Production;
    default:
      return null;
  }
};

export const STATUS = {
  COMPLETED: 'QUITADO',
  ON_TIME: 'EM_DIA',
  SUCCESS: 'EM_DIA_PAGO',
  LIGHT_DEBT: 'ATRASADO',
  CRITICAL_DEBT: 'ATRASADO_CRITICO',
  NEGOTIATED: 'NEGOCIACAO'
};

export const isExternalLink = (value) => {
  return value.match(/https?:\/\/[^\s/$.?#].[^\s]*/g);
}

export async function checkLocationPermission() {
  try {
    const permissionResult = await navigator.permissions.query({ name: 'geolocation' });

    switch (permissionResult.state) {
      case 'granted':
        console.log('Location permission is granted.');
        return true;
      case 'prompt':
        console.log('Location permission has not been granted yet and the user will be prompted.');
        return false;
      case 'denied':
        console.log('Location permission is denied.');
        return false;
      default:
        console.log('Unexpected permission state:', permissionResult.state);
        return false;
    }
  } catch (error) {
    console.error('Error checking location permission:', error);
    return false;
  }
}

export const requestLocationPermission = () => {
  return new Promise((accept,  reject) => {
    if (!navigator.geolocation) {
      reject('Geolocalização não é suportada pelo seu navegador.');
      return;
    }

    /*const userConfirmed = window.confirm(
      'Precisamos da sua permissão para acessar sua localização. Isso nos permitirá mostrar sua posição no mapa e calcular distâncias. Deseja continuar?'
    );

    if (!userConfirmed) {
      reject('Permissão de localização não concedida.');
      return;
    }*/

    navigator.geolocation.getCurrentPosition(
      (position) => {
       accept(position);
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject('Permissão de localização negada pelo usuário.');
            break;
          case error.POSITION_UNAVAILABLE:
            reject('Localização indisponível.');
            break;
          case error.TIMEOUT:
            reject('A solicitação de localização expirou.');
            break;
          default:
            reject('Ocorreu um erro ao obter a localização.');
            break;
        }
      },
      {
        enableHighAccuracy: false, // Retirar maior precisão
        timeout: 30000, // Tempo limite de 20 segundos
        maximumAge: 0, // Não usa cache
      }
    );
  });

};

export const doButtonMap = (imageUrl, styles = null) => {
  const centerControlDiv = document.createElement('button');
  centerControlDiv.title = 'Click to recenter the map';
  centerControlDiv.type = 'button';
  centerControlDiv.style.backgroundColor = '#fff';
  centerControlDiv.style.border = '2px solid #fff';
  centerControlDiv.style.borderRadius = '50%';
  centerControlDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
  centerControlDiv.style.color = 'rgb(25,25,25)';
  centerControlDiv.style.cursor = 'pointer';
  centerControlDiv.style.fontFamily = 'Roboto,Arial,sans-serif';
  centerControlDiv.style.fontSize = '16px';
  centerControlDiv.style.lineHeight = '38px';
  centerControlDiv.style.marginRight = '10px';
  centerControlDiv.style.padding = '0 5px';
  centerControlDiv.style.textAlign = 'center';
  centerControlDiv.style.width = '40px';
  centerControlDiv.style.height = '40px';
  centerControlDiv.style.display = 'flex';
  centerControlDiv.style.alignItems = 'center';
  centerControlDiv.style.justifyContent = 'center';
  if(styles){
    const keys = Object.keys(styles);
    keys.forEach(key => {
      centerControlDiv.style[key] = styles[key];
    });
  }
  const imgElement = document.createElement('img');
  imgElement.style.width = '20px';
  imgElement.style.height = '20px';
  imgElement.src = imageUrl;
  imgElement.alt = "Alt Image";
  centerControlDiv.appendChild(imgElement);
  return centerControlDiv;
}

export const doButtonMapMyLocation = () => {
  return doButtonMap('data:image/png;base64,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');
}

export const doButtonMapSensia = () => {
  return doButtonMap('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEc0lEQVR4Xs2Z32sUVxTH8ycE4syGFmFfxOz8SLYWldT1R2JtralJ1WJA224iKP7AbEvAGGLJ0kQfDFZ9KYU+LIIotJAVbasgRNoKSSkYKKIgNGligiUI+1AbzS9O77nJjrv3bNi9c2c2+4XPy9xzZ86599y5586UlXmg8nC4vNI2WjTbvKhbRjJgm6O6baV0y4Q0eC1gmfe4jR36qDIcDor3KarQ6UC1FUOnMh2VZFirNqNFDQYd1y0rLo6wMraZ8D0QXxwnGHHxucrCkdHYdNOH+QRbL57NhmYYLf6POoUNWKqCLXbRHynxlMlx8+LiMqVKw/k0kkHg1NGbrCyaaUZFP3MKF89K5Hw+cE0UtLDxDSB2LhXwTSj6m6XSyvvlMLpFv7l46hBjd9Rsr4f9R47Aya4uONZxCnZ/+glURSLEzg2YSlgNiP5j6iREY1m27d0DA/fvw8tXr0DUvy9ewJ2BAYg0NZJ+8giz4MXof/X1BVhYWBD9zqnvrl4l/WUgs6CxUlg0kqH+432ij/Dno0fww61b8OPdu/D306diM7zX3EzuI4NmhWJOALpinfP7gweOY5PPnkEdC0i02dS4G76/eZPbzMzMgLFlM7GRgc3CPe68avqgI7Ozs04A7fE4scmk7UwXtH7xObnuBp5Gum0r7bobd33gOI+q/bCB2PgF350Xj4G0sVCsbVvhv+lpJ4ATnaeJjV+g72WKR0LOH8PDTgD4ujza0UFs/MFIelI6HDh+zAkgrRt3bsOugweJraeYxii+gWiDC85euiTGwPXw8WOIfXkG1kY2kT6q4H7gWQDI4fZ2mHr+XIyBa2xiAs5dvgxvhGtIPxU8DQB5860wxPv6YHR8XIyBa5wFsqN5P+nnFgzAl9p/9dvroCXWBkMZm1xa/0xNwfqdO0kfN3iyiPOxgTn769BgVhC/DA5CwLaIrRR8EdtWkjT4QGW1Ddf6+50A5ufnobahgdjJwMsJ1Y1MhtDmSMYcAF/0oo0MfCNTrUSRNe/UkmvLMTc35wRworOTtMsQMIympW+dtLFQ8PQ1PjnJS+d1O94l7Zm8z0roTDVGPyM2MpRXVQUXzwMK5UR333nHoQlWSp/q6eFvINGubt9e+GtsLMs2uGE9sSsY03h9wA9YVowYFMghVhqLwjTB+uh6Mgn9P/8ET0ZGRBPo6O0h95Ih6zvRUhq53g9On+2F6ZevK9J8+vbKFXIPWZz0SUu3rG7RSAZz6xb4JpGAkYw0yRQe9H8bGoKmlijpK4tmGoks51Gqs5AG3/fb2ZEy2naSpUkvO6F1w57WVqipryO2biGjn5bqLBSDVeInFVG64gHfV7B0yCecHt2DVPKB1LKpI8qL3dlrKkKSf2tWldB6yJv3y6kUgnDtfFpL341WYk2kKgr9K5NPfGGzN0COh/gC26iGC16wMipCSqWUUyafcGRwK8/xcBW44+XBIP1x4Zd4IPgTXGHjwzIeK+GiOp5LGEzANpo0M3SRny3oh4LU4jUjyW2qzahXTv8PAZinWcXdWKoAAAAASUVORK5CYII=', { marginBottom: '10px' });
}
export const doButtonMapMrv = () => {
  return doButtonMap('data:image/svg+xml;base64,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', { marginBottom: '10px' });
}

export async function obterDadosDoUsuario() {
  const userAgent = navigator.userAgent;
  const dados = {
    navegador: "Navegador Desconhecido",
    sistemaOperacional: "Sistema Desconhecido",
    ip: "Indisponível"
  };

  let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  let temp;
  if (/trident/i.test(match[1])) {
    temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    dados.navegador = `Internet Explorer ${temp[1] || ''}`;
  } else if (match[1] === 'Chrome') {
    temp = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
    if (temp != null) {
      dados.navegador = temp.slice(1).join(' ').replace('OPR', 'Opera');
    } else {
      const versionMatch = userAgent.match(/Chrome\/([^\s]+)/);
      dados.navegador = `Chrome ${versionMatch ? versionMatch[1] : ''}`;
    }
  } else if (match[1]) {
    match = [match[1], userAgent.match(/Version\/([^\s]+)/)?.[1] || match[2]];
    dados.navegador = match.join(' ');
  }

  if (userAgent.indexOf("Win") > -1) {
    dados.sistemaOperacional = "Windows";
    if (userAgent.indexOf("Windows NT 10.0") > -1) {
      dados.sistemaOperacional = "Windows 10/11";
    }
  } else if (userAgent.indexOf("Mac") > -1) {
    dados.sistemaOperacional = "MacOS";
  } else if (userAgent.indexOf("Linux") > -1) {
    dados.sistemaOperacional = "Linux";
  } else if (userAgent.indexOf("Android") > -1) {
    dados.sistemaOperacional = "Android";
  } else if (userAgent.indexOf("like Mac") > -1) {
    dados.sistemaOperacional = "iOS";
  }

  try {
    const response = await fetch('https://api.ipify.org?format=json');
    if (!response.ok) {
      throw new Error(`Erro na rede: ${response.statusText}`);
    }
    const data = await response.json();
    dados.ip = data.ip;
  } catch (error) {
    console.error('Falha ao obter o endereço IP:', error);
  }

  return dados;
}

const processDownload = (content, titleParam = "Laudo") => {
  const blob = new Blob([content], { type: "application/pdf" });
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onloadend = () => {
    const base64data = reader.result;
    if (window.ReactNativeWebView) {
      let title = titleParam;
      title = title.replace(/[^a-zA-Z0-9,-]/g, "");
      const base64 = base64data.split(",")[1];
      window.ReactNativeWebView.postMessage(
          JSON.stringify({
            base64,
            filenamePrefix: title,
            extension: ".pdf",
          })
      );
    } else {
      doDownload(base64data, titleParam);
    }
  };
}

export const doDownloadVALaudo = async (idUnidade) => {
  const content = await downloadLaudoNew(
    idUnidade
  );
  processDownload(content);
};

export const doDownloadECDocument = async (idUnidade) => {
  const content = await downloadDocumentNew(
      idUnidade
  );
  processDownload(content, "TermoEC");
};

export const isIndicacaoDobro = () => {
  return false;
  /*const today = moment();
  const limitDate = moment().month(10).date(30).endOf('day');
  return !today.isAfter(limitDate);*/
}

export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371e3;
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};
